import { useShouldImport } from '@/vdp/VehicleDetailsContainer/hooks';
import {
  useGetIsWIPVehicle,
  useIsNewVehicle
} from '~/context/vdp/VehicleContext';

export default function useShowInspection() {
  const { importRecalls } = useShouldImport();
  const isNewVehicle = useIsNewVehicle();

  return !useGetIsWIPVehicle() && (!isNewVehicle || importRecalls);
}
